import React from 'react';

// eslint-disable-next-line func-names
export default function ({ institution, onClickOnInstitution }) {
  return (
    <div
      className="institution-card"
      key={institution.code}
      onClick={onClickOnInstitution(institution)}
      onKeyPress={onClickOnInstitution(institution)}
      role="button"
      tabIndex="0"
    >
      <img
        className="institution-icon"
        src={`/icons/institutions/${institution.code}.svg`}
        alt={institution.name}
      />
      <span className="institution-icon-label">{institution.code}</span>
    </div>
  );
}
